import classNames from 'classnames';
import React from 'react';

import Table from '@commons/Table';
import Row from '@commons/Table/Row';

import Anchor from '@components/RatingGrid/Anchor';

import './anchorBar.global.scss';

function createAnchors(anchors, shouldJustifyAnchors, isFirstRow, anchorStyles, questionId) {
  return anchors.map((anchor, idx) => (
    <Anchor
      key={idx}
      caption={anchor.text}
      containerStyles={anchorStyles}
      isJustified={shouldJustifyAnchors}
      isOnFirstRow={isFirstRow}
      isSelected={anchor.isSelected}
      questionId={questionId}
      id={idx}
    />
  ));
}

interface AnchorBarProps {
  anchors?: unknown[];
  anchorStyles?: string;
  isFirstRow?: boolean;
  isForcedDesktopShown?: boolean;
  shouldJustifyAnchors?: boolean;
}

export default function AnchorBar(props: AnchorBarProps) {
  const {
    anchors,
    hasNaOption,
    isFirstRow,
    isForcedDesktopShown,
    shouldJustifyAnchors,
    optionsQuantity,
    questionId
  } = props;

  const anchorStyles = `anchor_${optionsQuantity}column${hasNaOption ? '_na' : ''}`;

  const anchorsContainerStyles = classNames('anchors', {
    anchors_isFirstRow: isFirstRow,
    anchors_isForcedDesktopShown: isForcedDesktopShown
  });

  return (
    <Table containerStyles={anchorsContainerStyles}>
      <Row>
        {createAnchors(anchors, shouldJustifyAnchors, isFirstRow, anchorStyles, questionId)}
      </Row>
    </Table>
  );
}

AnchorBar.defaultProps = {
  anchors: [],
  anchorStyles: ''
};
